import { ORDER_APIS } from "@/api_framework/api_config";
import { IOrderManagementActionItemsResponse } from "@/api_framework/api_modals/Orders";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const useOrderForceStopDeliveryAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (subOrderId?: string): Promise<boolean> => {
    try {

      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
      const requestHeaders = new Headers();
      requestHeaders.append("Authorization", `${accessToken}`);

      const response = await axios
        .post(
          `${ORDER_APIS?.ORDER_FORCE_STOP_DELIVERY?.baseURL}`,
          { sub_order_id: subOrderId },
          {
            headers: {
              Authorization: requestHeaders.get("Authorization"),
              "Content-Type": "application/json",
            },
          },
        )
        .then((res: AxiosResponse<IOrderManagementActionItemsResponse>) => {
          const isSuccess = res?.status >= 200 && res?.status < 300;
          if (isSuccess) {
            toast.success("Rider assignment stopped successfully");
            return true;
          }
          toast.error("Failed to stop rider assignment");
          return false;
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config?.["curlCommand"]);
          captureError(e);
          toast.error("Failed to stop rider assignment");
          return false;
        });

      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      return false;
    }
  }, []);

  return execute;
};
